// src/config.js
export const API_BASE_URL = "https://bcsapp.com.br";